export const wrapperHeight = 708;
export const wrapperWidth = 900;
export const spacing = 80;
export const moduleTileWidth = 246;
export const currency = 'EUR';
